import React from 'react'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'
import { Modal, FormGroup, FormControl } from 'react-bootstrap'
import {skipJob} from '../api'
import {getOrdinalDate, getDateFromMillis} from '../shared/enums/date-parser'

export default React.createClass({

  getInitialState: function() {
    return {
       intervalType: 'weekly'
    }
  },
  toggleButton: function (index) {
    this.setState({
      selectedIndex: index
    })
    this.refs.btn0.setState({selected: index === 0})
    this.refs.btn1.setState({selected: index === 1})

    if(index === 0) {
      this.setState({intervalType: 'WEEKLY'})
    }
    else {
      this.setState({intervalType: 'BIWEEKLY'})
    }
  },
  sendSkipToServer: function() {
    let comment = document.getElementById('comment').value
    let jobId
    if(this.props.task) {
        jobId = this.props.task.mobileJob.jobId
    }
    else if(this.props.modalCard.jobId){
      jobId = this.props.modalCard.jobId
    }
    else {
      jobId = this.props.modalCard.mobileJob.jobId
    }
    skipJob(jobId, comment).then((data) => {
          if(data === 'okay') {
            this.props.openNotificationModal('skip-job-modal', "Your service has been updated!", "This task has been skipped.")
            this.props.hide()
          }
          else {
            this.props.openNotificationModal('skip-job-modal', "Processing Error", "There was an error processing your changes. Please try again later.")
            console.log("error")
          }
        })
  },
  render: function () {
    let card = this.props.modalCard
    let date, monthDay, taskType, taskTitle = '', taskIcon;

    if (card !== undefined && card !== '' && card !== null) {
	    if(card.millisDate) {
		    date = getOrdinalDate(card.millisDate)
		    monthDay = getDateFromMillis(card.millisDate)
	    }
	    else {
		    date = getOrdinalDate(card.estimatedStartTime)
		    monthDay = getDateFromMillis(card.estimatedStartTime)
	    }

	    taskType = card.taskType

	    let iconTypeInfo = getTaskTypeIconParser(taskType)
	    taskTitle = iconTypeInfo.prettify
	    taskIcon = iconTypeInfo.iconsrc
    }

    return (
      <div>
        <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='modal-no-radius'>
          <Modal.Header closeButton className='concrete-gray-background' style={{borderRadius: 6, paddingBottom: 40, paddingTop: 40}}>
            <div className={'task-type center no-text'}>
              <div className={`img-responsive center-block ${taskIcon}-icon`}/>
            </div>
            <h2 className='text-center'>{taskTitle}</h2>
            <h6 className='text-center'>Skip the job scheduled for <b>{date}</b></h6>
            <br />
            <div className='row' style={{width:'90%', margin:'auto'}}>
                <p className='text-center'>Please enter your reason for skipping this {taskTitle.toLowerCase()} job below</p>
              <FormGroup className='center-block' style={{width:'85%'}}>
                    <FormControl className='faq-text' componentClass='textarea' id='comment' placeholder='Reasons for skipping job' style={{height: 111, paddingTop: 20}}/>
              </FormGroup>
              </div>
              <p className='text-center pull-down-xs-1'>By clicking "Confirm", your job schedule for {monthDay} will be skipped.</p>
            <div className='text-center pull-down-xs-2'>
            <button className='btn btn-success' onClick={this.sendSkipToServer}>Confirm Skip</button>
            </div>
          </Modal.Header>
        </Modal>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/skip-job-modal.jsx